<template>
  <div
    class="flex overflow-x-auto gap-[20px] hide-scrollbar px-4 md:px-0"
    :class="{ 'no-select': isDragging }"
    @mousedown="startDragging"
    @mousemove="onDrag"
    @mouseup="stopDragging"
    @mouseleave="stopDragging"
    ref="scrollContainer"
  >
    <!-- Benefit Card -->
    <div
      class="w-[295px] h-[235px] p-[20px] bg-white rounded-xl flex flex-col space-y-4 flex-shrink-0 snap-center"
      v-for="(item, index) in benefit"
      :key="index"
    >
      <div class="flex flex-col gap-[10px] lg:gap-[20px]">
        <!-- Icon -->
        <div class="text-gray-800">
          <img class="w-[50px] h-[50px]" :src="item.icon_path" alt="" />
        </div>

        <!-- Title -->
        <h3
          class="text-[18px] md:text-[20px] lg:text-[24px] font-semibold text-gray-900"
        >
          {{ getLocalized(item, "title") }}
        </h3>

        <!-- Description -->
        <p class="text-gray-600 text-[15px]">
          {{ truncatedDescription(getLocalized(item, "description")) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";

export default {
  mounted() {
    this.fetchBenefits();
  },
  data() {
    return {
      benefit: [],
      api: process.env.VUE_APP_API_KEY,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  methods: {
    async fetchBenefits() {
      try {
        const response = await axios.get(this.api + "/api/benefits");
        this.benefit = response.data.items;
        this.benefit = this.benefit
          .map((item) => ({
            ...item,
            icon_path: `${this.api}${item.icon_path}`,
          }))
          .sort((a, b) => a.display_order - b.display_order);
      } catch (e) {
        console.error(e);
      }
    },
    truncatedDescription(description) {
      const maxLength = 140; // Maximum number of characters to display
      if (description.length > maxLength) {
        return description.slice(0, maxLength) + "...";
      }
      return description;
    },
    startDragging(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walk = (x - this.startX) * 2; // Adjust scroll speed
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk;
    },
    stopDragging() {
      this.isDragging = false;
    },
  },
};
</script>

<style>
/* Hide scrollbar for all browsers */
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* Enable smooth scrolling and snapping */
.snap-x {
  scroll-snap-type: x mandatory; /* Horizontal snap */
}
.snap-center {
  scroll-snap-align: center; /* Center align the elements */
}
/* Prevent text selection while dragging */
.no-select {
  user-select: none; /* Disable text selection */
}
</style>
